import React, { useState } from "react";
import HomeBanner from "./HomeBanner";
import homeElm from "../assets/home-Right.jpg";
import icon1 from "../assets/homeGrid/icon1-1.png";
import icon2 from "../assets/homeGrid/icon2.png";
import icon3 from "../assets/homeGrid/icon3-1.png";
import icon4 from "../assets/homeGrid/icon4.png";
import icon5 from "../assets/homeGrid/icon5.png";
import icon6 from "../assets/homeGrid/icon6.png";
import { Card } from "primereact/card";

export default function Home() {
  return (
    <div>
      <HomeBanner />
      <div className="p-3 md:p-5">
        {/* Center Title */}
        <div className="center-text-section">
          <h2>IBM JAZZ ENGINEERING PLATFORM</h2>
          <p>
            IBM Jazz Platform embodies an innovative approach to integration
            based on open flexible services and Internet architecture.
          </p>
        </div>

        {/* Main Grid */}
        <div className="grid align-items-stretch">
          {/* LEFT IMAGE */}
          <div className="col-12 md:col-6 p-3 flex">
            <img
              src={homeElm}
              alt="Services"
              className="w-full border-round"
              style={{ objectFit: "cover" }}
            />
          </div>

          {/* RIGHT CARDS */}
          <div className="col-12 md:col-6">
            <div className="grid">
              <div className="col-12 sm:col-6 p-3">
                <Card title="DOORS Next Generation" className="h-full">
                  <p>
                    Manage requirements efficiently to reduce your development
                    costs and speed time to market
                  </p>
                </Card>
              </div>

              <div className="col-12 sm:col-6 p-3">
                <Card
                  title="Engineering Systems Design Rhapsody"
                  className="h-full"
                >
                  <p>
                    New design management server for IBM Engineering Systems
                    Design Rhapsody
                  </p>
                </Card>
              </div>

              <div className="col-12 sm:col-6 p-3">
                <Card
                  title="Engineering Workflow Management"
                  className="h-full"
                >
                  <p>
                    Use one tool to collaborate across teams, manage code, run
                    standup meetings, plan sprints, and track work
                  </p>
                </Card>
              </div>

              <div className="col-12 sm:col-6 p-3">
                <Card
                  title="Engineering Test Management"
                  className="h-full border-round-lg"
                >
                  <p>
                    Increase efficiency and quality of systems and software
                    delivery with test planning, workflow control, tracking, and
                    metrics reporting
                  </p>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="center-text-section">
        <h2>What do we do with IBM Products?</h2>
        {/* <p>
          IBM Jazz Platform embodies an innovative approach to integration
          based on open flexible services and Internet architecture.
        </p> */}
      </div>
      <div className="services-wrapper">
        <div className="grid">
          {/* LEFT CARD */}

          {/* RIGHT CARD */}
          <div className="col-12 md:col-4">
            <Card className="service-card">
              <img src={icon1} alt="Training" className="service-image" />

              <p className="company-highlight text-center mt-4">
                Requirements Analysis & Demos
              </p>

              <p className="service-text">
                We can help you to decide how to do the right implementations
                and how to get the most value from the IBM products. We
                calculate ROI cases and Identify/develop required capabilities
                using IBM software products.
              </p>
            </Card>
          </div>
          <div className="col-12 md:col-4">
            <Card className="service-card">
              <img src={icon2} alt="Training" className="service-image" />

              <p className="company-highlight text-center mt-4">
                Licensing & Sale
              </p>

              <p className="service-text">
                We consider our clients usage model and recommend the most
                suitable license, contract and usage model. Depending on
                customer requirements we sell the license, services and provide
                extensions.
              </p>
            </Card>
          </div>
          <div className="col-12 md:col-4">
            <Card className="service-card">
              <img src={icon3} alt="Training" className="service-image" />

              <p className="company-highlight text-center mt-4">
                Installations, Upgrades & Tuning
              </p>

              <p className="service-text">
                If you need to deploy IBM software quickly and professionally
                and integrate it into your internal systems, we can help you. We
                often update, improve or repair customer installations.
              </p>
            </Card>
          </div>
          <div className="col-12 md:col-4">
            <Card className="service-card">
              <img src={icon4} alt="Training" className="service-image" />

              <p className="company-highlight text-center mt-4">
                Consulting & Setup
              </p>

              <p className="service-text">
                It is very important that you use the products with the greatest
                possible benefit and that the product is adapted to your process
                and your company language. We help customers set up the products
                correctly.
              </p>
            </Card>
          </div>
          <div className="col-12 md:col-4">
            <Card className="service-card">
              <img src={icon5} alt="Training" className="service-image" />

              <p className="company-highlight text-center mt-4">
                Account Management
              </p>

              <p className="service-text">
                We consider customer needs with a long-term focus of success and
                a good business relationship. This includes license management,
                regulatory compliance, product and license advice, terms of use,
                and related topics in all areas related to IBM's diversity.
              </p>
            </Card>
          </div>
          <div className="col-12 md:col-4">
            <Card className="service-card">
              <img src={icon6} alt="Training" className="service-image" />

              <p className="company-highlight text-center mt-4">
                Extensions & Templates
              </p>

              <p className="service-text">
                If your IBM application lacks something special that your daily
                job must have solved, we develop toolkits and extensions for the
                IBM products so that they work for you. We also provide
                templates to accelerate adoption and for specific use cases in
                the industry.
              </p>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
